module.exports = __webpack_public_path__ + "504b04bd456b90874f76269491610389.svg";